import React, { useState, useEffect } from 'react';
import { apiFetch } from '../services/api';
import './MarketingContacts.css';

function MarketingContacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadContacts();
  }, []);

  const loadContacts = async () => {
    try {
      // Buscar apenas contatos do Wati (payment_type = wati_sync)
      const response = await apiFetch('/api/clients?payment_type=wati_sync');
      // Ajuste conforme a estrutura da sua API (pode ser response.data ou response diretamente)
      const contactsData = response.data || response;
      setContacts(contactsData);
    } catch (error) {
      console.error('Erro ao carregar contatos:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredContacts = contacts.filter(contact =>
    contact.full_name?.toLowerCase().includes(search.toLowerCase()) ||
    contact.phone?.includes(search)
  );

  if (loading) return <div className="loading">Carregando contatos...</div>;

  return (
    <div className="marketing-contacts-page">
      <div className="page-header">
        <h1>📱 Contatos WhatsApp (Leads)</h1>
        <p className="subtitle">Pessoas que interagiram via WhatsApp - ainda não são clientes</p>
      </div>

      <div className="contacts-toolbar">
        <div className="search-box">
          <input
            type="text"
            placeholder="Buscar por nome ou telefone..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button className="btn-sync" onClick={loadContacts}>
          🔄 Sincronizar
        </button>
      </div>

      <div className="contacts-stats">
        <div className="stat-card">
          <span className="stat-value">{contacts.length}</span>
          <span className="stat-label">Total de Contatos</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">0</span>
          <span className="stat-label">Convertidos em Clientes</span>
        </div>
      </div>

      <div className="contacts-table-container">
        <table className="contacts-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Telefone</th>
              <th>Email</th>
              <th>Data de Criação</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredContacts.map(contact => (
              <tr key={contact.id}>
                <td className="contact-name">{contact.full_name || '—'}</td>
                <td>{contact.phone}</td>
                <td>{contact.email || '—'}</td>
                <td>{new Date(contact.created_date).toLocaleDateString()}</td>
                <td className="contact-actions">
                  <button className="btn-convert" title="Converter em Cliente">
                    ➕
                  </button>
                  <button className="btn-message" title="Enviar Mensagem">
                    💬
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MarketingContacts;